import React, {useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {
	Backdrop,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	FormControl,
	InputLabel, MenuItem, Select,
	Typography
} from "@mui/material";
import clsx from "clsx";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import Grid from "@mui/material/Grid";
import ResizableBox, {radarOptions} from "../../utils/ResizableBox";
import {Radar} from "react-chartjs-2";

export const TicketUser = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	dataGrafico.setDate(dataGrafico.getDate() - 1)
	const [utente, setUtente] = useState("");
	const [utenti, setUtenti] = useState([]);
	const [loading, setLoading] = useState(false);
	const [data2All, setData2All] = useState([])
	
	const [data, setData] = useState({
		labels: ['Nuovi', 'Aperti', 'Presi in carico', 'In attesa', 'Risolti'],
		datasets: [
			{
				label: 'Nick Fury',
				data: [2, 9, 3, 5, 2],
				backgroundColor: 'rgba(255, 99, 132, 0.2)',
				borderColor: 'rgba(255, 99, 132, 1)',
				borderWidth: 1,
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "ticket/getStatsByUser/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				setData2All(response.data);
				let utenti = [];
				response.data.forEach(item => utenti.push(item.label));
				setUtenti(utenti.sort());
				setUtente(utenti[0])
				setLoading(false);
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	useEffect(() => {
		if (utente !== "") {
			data2All.forEach((item) => {
				if (item.label === utente) {
					setData({
						labels: Object.keys(item.data),
						datasets: [
							{
								label: utente,
								data: Object.keys(item.data).map(key => item.data[key]),
								backgroundColor: 'rgba(255, 99, 132, 0.2)',
								borderColor: 'rgba(255, 99, 132, 1)',
								borderWidth: 1,
							}
						]
					});
				}
			})
		}
	}, [utente, data2All])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket operatore</b></Typography>}
					subheader={"Numero di ticket per operatore per stato"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<Grid container spacing={3}>
						<Grid item xs={12}>
							{
								loading ? "...wait..." :
									<FormControl variant="outlined" fullWidth={true}>
										<InputLabel id="demo-simple-select-outlined-label">Seleziona un utente</InputLabel>
										<Select
											labelId="demo-simple-select-outlined-label"
											id="demo-simple-select-outlined"
											fullWidth={true}
											value={utente}
											onChange={e => setUtente(e.target.value)}
											label="Seleziona un utente"
										>
											<MenuItem value="">
												<em>None</em>
											</MenuItem>
											{
												utenti.map((utente, index) => {
													return (<MenuItem key={index} value={utente}>
														{utente}
													</MenuItem>)
												})
											}
										</Select>
									</FormControl>
							}
						</Grid>
						<Grid item xs={12}>
							<ResizableBox width={700} height={700}>
								<Radar data={data} type={"radar"} tabIndex={0} options={radarOptions}/>
							</ResizableBox>
						</Grid>
					</Grid>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
}
